import { z } from "zod";

import {
  DOCX_MEDIA_TYPE,
  PDF_MEDIA_TYPE,
  PDF_TO_DOCX_MAX_FILE_SIZE,
} from "./capabilities";

export const assetStatusSchema = z.enum([
  "CREATED",
  "UPLOADING",
  "UPLOADED",
  "VALIDATED",
  "PROCESSING",
  "READY",
  "DELETED",
  "REJECTED",
]);

export type AssetStatus = z.infer<typeof assetStatusSchema>;

export const documentFormatSchema = z.enum(["pdf", "docx"]);
export type DocumentFormat = z.infer<typeof documentFormatSchema>;

export const documentAssetSchema = z.object({
  id: z.string().min(1),
  originalName: z.string().min(1),
  mediaType: z.enum([PDF_MEDIA_TYPE, DOCX_MEDIA_TYPE]),
  detectedFormat: documentFormatSchema.nullable(),
  sizeBytes: z.number().int().nonnegative(),
  checksum: z.string().nullable(),
  status: assetStatusSchema,
  expiresAt: z.string().datetime(),
  createdAt: z.string().datetime(),
});

export type DocumentAssetDto = z.infer<typeof documentAssetSchema>;

export const createUploadSessionRequestSchema = z
  .object({
    fileName: z.string().trim().min(1).max(255),
    contentType: z.literal(PDF_MEDIA_TYPE),
    size: z.number().int().positive().max(PDF_TO_DOCX_MAX_FILE_SIZE),
  })
  .strict();

export type CreateUploadSessionRequest = z.infer<
  typeof createUploadSessionRequestSchema
>;

export const createUploadSessionResponseSchema = z.object({
  assetId: z.string().min(1),
  uploadUrl: z.string().url(),
  storageKey: z.string().min(1),
  expiresAt: z.string().datetime(),
});

export type CreateUploadSessionResponse = z.infer<
  typeof createUploadSessionResponseSchema
>;

export const completeUploadResponseSchema = z.object({
  asset: documentAssetSchema,
});

export type CompleteUploadResponse = z.infer<
  typeof completeUploadResponseSchema
>;

export const downloadSessionResponseSchema = z.object({
  assetId: z.string().min(1),
  downloadUrl: z.string().url(),
  fileName: z.string().min(1),
  expiresAt: z.string().datetime(),
});

export type DownloadSessionResponse = z.infer<
  typeof downloadSessionResponseSchema
>;

export const deleteAssetResponseSchema = z.object({ deleted: z.literal(true) });
